export var navbp = {
  mobilePortraits: '480px',
  wideViewports: '948px',
  ipadLandscape: '1025px',
  extraWideViewport: '1280px'
};
export var NAV_HEIGHT = 64;
export var RIBBON_HEIGHT = '80px';
export var RIBBON_WIDTH = '57px';
export var HAMBURGER_MENU_ID = 'navToggle';